import type { SVGProps } from "react";

export default function FilterIconAlternative(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 5.83333C2.5 5.3731 2.8731 5 3.33333 5H16.6667C17.1269 5 17.5 5.3731 17.5 5.83333C17.5 6.29357 17.1269 6.66667 16.6667 6.66667H3.33333C2.8731 6.66667 2.5 6.29357 2.5 5.83333ZM5 10C5 9.53975 5.3731 9.16667 5.83333 9.16667H14.1667C14.6269 9.16667 15 9.53975 15 10C15 10.4602 14.6269 10.8333 14.1667 10.8333H5.83333C5.3731 10.8333 5 10.4602 5 10ZM7.5 14.1667C7.5 13.7064 7.8731 13.3333 8.33333 13.3333H11.6667C12.1269 13.3333 12.5 13.7064 12.5 14.1667C12.5 14.6269 12.1269 15 11.6667 15H8.33333C7.8731 15 7.5 14.6269 7.5 14.1667Z"
        fill="currentColor"
      />
    </svg>
  );
}
